import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import FactoryDebtCorrectionItemForm from "../create/components/FactoryDebtCorrectionItemForm";
import FactoryDebtCorrectionJournalForm from "../create/components/FactoryDebtCorrectionJournalForm";
import FactoryDebtCorrectionItemEditForm from "../edit/components/FactoryDebtCorrectionItemForm";
import FactoryDebtCorrectionJournalEditForm from "../edit/components/FactoryDebtCorrectionJournalForm";
import { useState } from "react";
import { useTranslate } from "react-admin";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {children}
    </div>
  );
}

const TabForm = ({ schema, ...props }) => {
  const t = useTranslate();
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <Box sx={{ width: "100%" }}>
      <Box
        sx={{
          borderBottom: 1,
          borderColor: "divider",
          bgcolor: "background.paper",
          mb: 1,
        }}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          variant="fullWidth"
        >
          <Tab
            label={t("mine.label.correction")}
            sx={value === 0 ? { bgcolor: "grey.200" } : {}}
          />
          <Tab
            label={t("mine.label.journal")}
            sx={value === 1 ? { bgcolor: "grey.200" } : {}}
          />
        </Tabs>
      </Box>
      {schema === "edit" ? (
        <>
          <TabPanel value={value} index={0}>
            <FactoryDebtCorrectionItemEditForm />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <FactoryDebtCorrectionJournalEditForm />
          </TabPanel>
        </>
      ) : (
        <>
          <TabPanel value={value} index={0}>
            <Box
              sx={{
                maxHeight: '300px', // Sesuaikan tinggi maksimum sesuai kebutuhan Anda
                overflowY: 'auto',
                border: '1px solid #ccc', // Opsional: untuk visualisasi batas
                borderRadius: '4px',
                marginBottom: '24px',
                p: 1, // Opsional: padding
              }}
            >
            <FactoryDebtCorrectionItemForm />
            </Box>
          </TabPanel>
          <TabPanel value={value} index={1}>
            <Box
                          sx={{
                            maxHeight: '300px', // Sesuaikan tinggi maksimum sesuai kebutuhan Anda
                            overflowY: 'auto',
                            border: '1px solid #ccc', // Opsional: untuk visualisasi batas
                            borderRadius: '4px',
                            marginBottom: '24px',
                            p: 1, // Opsional: padding
                          }}
                        >
            <FactoryDebtCorrectionJournalForm />
            </Box>
          </TabPanel>
        </>
      )}
    </Box>
  );
};

export default TabForm;
